import React, { useEffect } from 'react'
import { Link, Events } from 'react-scroll'

interface IProps {
  open: boolean
  requestClose: () => void
}

export const SpGlobalMenus = (props: IProps) => {

  useEffect(() => {
    Events.scrollEvent.register("end", () => {
      props.requestClose()
    })
    return () => {
      Events.scrollEvent.remove("end")
    }
  })

  return (
    <nav className={`sp-global-menus ${props.open && "sp-global-menus--open"}`}>
      <div className="sp-global-menus--overlay" onClick={props.requestClose} />
      <ul>
        <li><Link to="page-system" smooth={true} duration={300}>システムの特徴</Link></li>
        <li><Link to='page-aligner' smooth={true} duration={300}>アライナーの特徴</Link></li>
        <li><Link to='page-value' smooth={true} duration={300}>提供価値</Link></li>
        <li><Link to='page-example' smooth={true} duration={300}>導入事例</Link></li>
        <li><Link to='page-owner' smooth={true} duration={300}>創業者の想い</Link></li>
      </ul>
    </nav>
  )
}